import React, { ReactNode } from 'react'
import { TableCell } from '@mui/material'
import { getStickyCellSx, StickyCell } from '../DataTable.sticky'
import { DataTableAlign } from '../DataTable.types'

type DataTableBodyCellProps = {
    children: ReactNode
    width: string
    align?: DataTableAlign
    paddingX?: number
    paddingY?: number
    isFirstColumn?: boolean
    isLastColumn?: boolean
    isFirstRow?: boolean
    isLastRow?: boolean
    sticky?: StickyCell
    background?: string
}
export const DataTableBodyCell = ({
    children,
    width,
    align = 'left',
    paddingX = 2,
    paddingY = 2,
    isFirstColumn = false,
    isLastColumn = false,
    isFirstRow = false,
    isLastRow = false,
    sticky,
    background = '',
}: DataTableBodyCellProps) => (
    <TableCell
        align={align}
        sx={[
            {
                width,
                px: paddingX,
                py: paddingY,
                verticalAlign: 'middle',
                borderBottom: 'none',
                ...(isFirstColumn && {
                    borderTopLeftRadius: isFirstRow ? '8px' : 0,
                    borderBottomLeftRadius: isLastRow ? '8px' : 0,
                }),
                ...(isLastColumn && {
                    borderTopRightRadius: isFirstRow ? '8px' : 0,
                    borderBottomRightRadius: isLastRow ? '8px' : 0,
                }),
            },
            getStickyCellSx(sticky, background),
        ]}
    >
        {children}
    </TableCell>
)

export default DataTableBodyCell
